/* Drag&Drop — PDP share restore — 2026-08-18 */
(() => {
  'use strict';
  const DD_SHARE_COPY={"tr":{"aria":"Ürünü paylaş","share":"Paylaş","copied":"Kopyalandı"},"en":{"aria":"Share product","share":"Share","copied":"Copied"},"es":{"aria":"Compartir producto","share":"Compartir","copied":"Copiado"},"ru":{"aria":"Поделиться товаром","share":"Поделиться","copied":"Скопировано"},"ar":{"aria":"مشاركة المنتج","share":"مشاركة","copied":"تم النسخ"},"de":{"aria":"Produkt teilen","share":"Teilen","copied":"Kopiert"},"fr":{"aria":"Partager le produit","share":"Partager","copied":"Copié"}};
  const ddShareCopy=()=>DD_SHARE_COPY[String(document.documentElement.lang||"tr").toLowerCase().split("-")[0]]||DD_SHARE_COPY.tr;
  const VERSION = '2026-08-18-pdp-share-v45';
  if (window.__ddPdpShareV45 === VERSION) return;
  window.__ddPdpShareV45 = VERSION;

  function icon() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 16V4m0 0L8 8m4-4 4 4M5 13v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  async function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    document.execCommand('copy');
    area.remove();
  }

  function setCopied(button) {
    const label = button.querySelector('.dd-pdp-share-v45__label');
    if (!label) return;
    const original = label.textContent;
    label.textContent = ddShareCopy().copied;
    window.setTimeout(() => { label.textContent = original; }, 1500);
  }

  function enhance(section) {
    if (!(section instanceof Element)) return;
    const topRow = section.querySelector('.fhp-top-row');
    if (!topRow || topRow.querySelector('[data-dd-pdp-share-v45]')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'dd-pdp-share-v45';
    button.dataset.ddPdpShareV45 = 'true';
    button.setAttribute('aria-label', ddShareCopy().aria);
    button.innerHTML = icon() + '<span class="dd-pdp-share-v45__label">' + ddShareCopy().share + '</span>';

    button.addEventListener('click', async () => {
      const title = section.querySelector('.fhp-title')?.textContent?.trim() || document.title;
      const url = window.location.href;
      try {
        if (navigator.share) {
          await navigator.share({ title, url });
          return;
        }
        await copyText(url);
        setCopied(button);
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        try {
          await copyText(url);
          setCopied(button);
        } catch (_) {}
      }
    });

    topRow.appendChild(button);
  }

  function apply(root) {
    const scope = root || document;
    if (scope instanceof Element && scope.matches('[data-fhp-root]')) enhance(scope);
    scope.querySelectorAll?.('[data-fhp-root]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(document), { once: true });
  } else {
    apply(document);
  }

  document.addEventListener('shopify:section:load', event => apply(event.target || document));
})();
